import clsx from "clsx";
import { FC, MouseEventHandler, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { useCrudEditContext } from "@ryde/redux";
import {
  isInnerItemEditingAtom,
  IStationRouteDto,
  useIsMobile,
} from "@ryde/shared";

import {
  LayoutRightHeaderStartButtonsStyled,
  LayoutRightHeaderTitleStyled,
} from "../../../right";
import { StationRouteHeaderButtons } from "./station-route.header.buttons";
import { StationRouteHeaderInfos } from "./station-route.header.infos";
import {
  HeaderLine1Styled,
  StationRouteHeaderStyled,
} from "./station-route.header.styled";

interface IStationRouteHeaderProps extends PropsWithChildren {
  headerTitle?: string;
  subHeaderTitle?: string;
  closeClick?: MouseEventHandler<Element>;
}

export const StationRouteHeader: FC<IStationRouteHeaderProps> = ({
  headerTitle,
  closeClick,
}) => {
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const {
    data: { dto: stationRouteDto },
  } = useCrudEditContext<IStationRouteDto>();
  const isInnerItemEditing = useRecoilValue(isInnerItemEditingAtom);
  const isCustomizedPath = Boolean(stationRouteDto?.customized);
  const customizedBadge = isCustomizedPath ? (
    <span className="station-route-header-customized-badge">
      <span className="station-route-header-customized-sparkle" aria-hidden>
        ✨
      </span>
      {t("stationRoute.formLabel.customized")}
    </span>
  ) : null;

  return (
    <StationRouteHeaderStyled
      className={clsx(
        "StationRouteDrawer-Header",
        isInnerItemEditing && "inner-item-editing",
      )}
    >
      <LayoutRightHeaderStartButtonsStyled>
        {closeClick && (
          <SVG_MUI.XMarkSVG onClick={closeClick} className="close" />
        )}
      </LayoutRightHeaderStartButtonsStyled>
      {isMobile && (
        <>
          <HeaderLine1Styled>
            {headerTitle}
            {customizedBadge}
          </HeaderLine1Styled>
          <StationRouteHeaderButtons />
        </>
      )}
      {!isMobile && (
        <>
          <LayoutRightHeaderTitleStyled className="StationRouteDrawer-HeaderTitle">
            <HeaderLine1Styled>
              {headerTitle}
              {customizedBadge}
            </HeaderLine1Styled>
            <StationRouteHeaderInfos />
          </LayoutRightHeaderTitleStyled>
          <StationRouteHeaderButtons />
        </>
      )}
    </StationRouteHeaderStyled>
  );
};
